export const getters = {
  systemProducts: state => state.products,
  systemProductstat: state => state.statproductsales,
  systemTotalsales: state => state.total,
  systemTotalpurchases: state => state.topPurchasedProducts,
  systemTotalSales: state => state.topSoldProducts,
  getsystemProducts: state => state.singleproducts,
  deadsystemProducts: state => state.deadproducts,
  Product: state => state.systemProduct,
  Productnumber: state => state.prod_no,
  getProductsprice: state => state.sellprice
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/getters.js